import type {
  BUTTON_CHOICE_LAYOUT_TYPE,
  Choice,
  IconChoice,
  IMAGE_CHOICE_UI_SUBTYPE,
  ImageChoice,
  InfographicChoice
} from '../choices'
import type { BLOCK_TYPE } from '../enums'

import type { BlockBaseSettings, IBlock } from './base'

export enum MULTIPLE_CHOICE_CONTROL_TYPE {
  CHECKBOX = 'checkbox',
  BUTTON = 'button',
  IMAGE_BUTTON = 'imageButton'
}

type SharedSettings = {
  maxSelection: number | 'Infinity'
}

export interface IMultipleChoiceBlock extends IBlock {
  type: BLOCK_TYPE.MULTIPLE_CHOICE
  settings: BlockBaseSettings &
    SharedSettings & {
      /** Which UI type to render as */
      uiType: MULTIPLE_CHOICE_CONTROL_TYPE
      /** Which rendering style should be used for image-enabled choices */
      imageType?: never | IMAGE_CHOICE_UI_SUBTYPE
      /** Which choices to offer */
      choices: Choice | ImageChoice[]
      /** Which button layout option to use */
      buttonType?: never | BUTTON_CHOICE_LAYOUT_TYPE
    }
}

export interface CheckboxMultipleChoiceBlock extends IMultipleChoiceBlock {
  settings: BlockBaseSettings &
    SharedSettings & {
      uiType: MULTIPLE_CHOICE_CONTROL_TYPE.CHECKBOX
      imageType?: never
      choices: Choice[]
      buttonType?: never
    }
}

export interface ButtonMultipleChoiceBlock extends IMultipleChoiceBlock {
  settings: BlockBaseSettings &
    SharedSettings & {
      uiType: MULTIPLE_CHOICE_CONTROL_TYPE.BUTTON
      imageType?: never
      choices: Choice[]
      buttonType: BUTTON_CHOICE_LAYOUT_TYPE
    }
}

export interface InfographicMultipleChoiceBlock extends IMultipleChoiceBlock {
  settings: BlockBaseSettings &
    SharedSettings & {
      uiType: MULTIPLE_CHOICE_CONTROL_TYPE.IMAGE_BUTTON
      /** Which rendering style should be used for the images */
      imageType: IMAGE_CHOICE_UI_SUBTYPE.INFOGRAPHIC
      choices: InfographicChoice[]
      buttonType?: never
    }
}

export interface IconMultipleChoiceBlock extends IMultipleChoiceBlock {
  settings: BlockBaseSettings &
    SharedSettings & {
      uiType: MULTIPLE_CHOICE_CONTROL_TYPE.IMAGE_BUTTON
      imageType: IMAGE_CHOICE_UI_SUBTYPE.ICON
      choices: IconChoice[]
      buttonType?: never
    }
}

export interface ImageButtonMultipleChoiceBlock extends IMultipleChoiceBlock {
  settings: BlockBaseSettings &
    SharedSettings & {
      uiType: MULTIPLE_CHOICE_CONTROL_TYPE.IMAGE_BUTTON
      /** Which rendering style should be used for the images */
      imageType: IMAGE_CHOICE_UI_SUBTYPE
      choices: ImageChoice[]
      buttonType?: never
    }
}

export type MultipleChoiceBlock =
  | CheckboxMultipleChoiceBlock
  | ButtonMultipleChoiceBlock
  | ImageButtonMultipleChoiceBlock
